/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/download'
export default icon
